export default "/images/784376f9bbe00d2beaa4d26ed41e3fb9.png";